export default "__VITE_ASSET__xz0mvxi$__"